// extracted by mini-css-extract-plugin
export var card = "_6p-0";
export var content = "_6p-1";
export var contentLoading = "_6p-2";